import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';

import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';

import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { GetFlashStatusRequest } from '../api/flashmessage/getflashstatus/getflashstatusrequest';
import { GetFlashStatusResponse, GetFlashStatusResponseDtoImpl } from '../api/flashmessage/getflashstatus/getflashstatusresponse';

export class GetFlashStatusAPIProcessorImpl extends APIProcessorImpl<GetFlashStatusRequest, GetFlashStatusResponse>
{
    // execute(): void 
    // {
    //     let flashmessagedto = new FlashMessageSubscriptionDetailsDtoImpl();
    //     let response = new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, "Get GetFlashStatus Success");
    //     flashmessagedto.setIsNewUser(false);
    //     flashmessagedto.setStatus("A");
    //     response.setGetFlashStatusResponseDto(flashmessagedto);
    //     this.getAPISuccess(response);
    // }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, "Get GetFlashStatus Success");
                if(+responseMapper.getStatusCodeOutside() === 0)
                {
                    response.setFlashStatus(responseMapper.getResponseMap().
                    subscriptionStatus === "INACTIVE" ? "D" : "A");
                    this.getAPISuccess(response);
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.NO_CONTENT)
                {
                    this.getAPISuccess(new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, this.getContext().getResources().getString(Strings.no_data_list_available)));
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.INTERNAL_SERVER_ERROR)
                {
                    this.getAPIFailure(new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, this.getContext().getResources().getString(Strings.internal_server_error)));
                }
                else
                {
                    this.getAPIFailure(new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, responseMapper.getStatusMsg()));
                }
                
                
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
      
            this.getAPIFailure(new GetFlashStatusResponseDtoImpl(APIFeatures.GET_FLASH_STATUS, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getflashstatusapiprocessor.tsx